module.exports = __webpack_public_path__ + "static/media/russia-flag.23e49722.png";